var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Modal",
    {
      attrs: { "show-footer": false, "show-title": false },
      on: { ok: _vm.confirm, cancel: _vm.close },
    },
    [
      _c("div", { staticClass: "create-plan-information" }, [
        _c("div", { staticClass: "svg-banner" }, [_c("Discount")], 1),
        _vm._v(" "),
        _c("div", { staticClass: "discount" }, [
          _vm._v(_vm._s(_vm.$t("message.annualPurchaseDiscount"))),
        ]),
        _vm._v(" "),
        _vm.planPeriod == "monthly"
          ? _c("div", { staticClass: "description" }, [
              _vm._v(
                "\n           " +
                  _vm._s(_vm.$t("message.packagePurchaseConfirmation")) +
                  "\n        "
              ),
            ])
          : _c("div", { staticClass: "description" }, [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$t("message.packageConfirmationMessage")) +
                  "\n        "
              ),
            ]),
        _vm._v(" "),
        _c("div", { staticClass: "footer" }, [
          _c(
            "div",
            { staticClass: "subbutton cancel", on: { click: _vm.close } },
            [_vm._v(_vm._s(_vm.$t("billing.cancelIt")))]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "subbutton", on: { click: _vm.confirm } }, [
            _vm._v(_vm._s(_vm.$t("billing.buyIt"))),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }